
<div class="modal-header">
  <h5 class="modal-title">{{ catalogItem?.id ? 'Edit' : 'Add' }} Catalog Item</h5>
  <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="isbn">
            ISBN
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the ISBN of the book.<br><b>Example:</b> 978-3-16-148410-0"></i>
          </label>
          <input type="text" class="form-control" id="isbn" [(ngModel)]="catalogItem.isbn" name="isbn" placeholder="e.g., 978-3-16-148410-0">
        </div>

        <div class="form-group">
          <label for="title">
            Title
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the title of the book.<br><b>Example:</b> The Great Gatsby"></i>
          </label>
          <input type="text" class="form-control" id="title" [(ngModel)]="catalogItem.title" name="title" placeholder="e.g., The Great Gatsby">
        </div>

        <div class="form-group">
          <label for="edition">
            Edition
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the edition of the book.<br><b>Example:</b> 1st Edition"></i>
          </label>
          <input type="text" class="form-control" id="edition" [(ngModel)]="catalogItem.edition" name="edition" placeholder="e.g., 1st Edition">
        </div>

        <div class="form-group">
          <label for="editionYear">
            Edition Year
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the year of the edition.<br><b>Example:</b> 2020"></i>
          </label>
          <input type="text" class="form-control" id="editionYear" [(ngModel)]="catalogItem.edition_year" name="editionYear" placeholder="e.g., 2020">
        </div>

       <!--  <div class="form-group">
          <label for="photo">
            Photo URL
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the URL for the book's photo.<br><b>Example:</b> https://example.com/photo.jpg"></i>
          </label>
          <input type="text" class="form-control" id="photo" [(ngModel)]="catalogItem.photo" name="photo" placeholder="e.g., https://example.com/photo.jpg">
        </div> -->

        <div class="form-group">
          <label for="publishingYear">
            Publishing Year
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the year the book was published.<br><b>Example:</b> 2021"></i>
          </label>
          <input type="text" class="form-control" id="publishingYear" [(ngModel)]="catalogItem.publishing_year" name="publishingYear" placeholder="e.g., 2021">
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="publicationPlace">
            Publication Place
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter where the book was published.<br><b>Example:</b> New York"></i>
          </label>
          <input type="text" class="form-control" id="publicationPlace" [(ngModel)]="catalogItem.publication_place" name="publicationPlace" placeholder="e.g., New York">
        </div>

        <div class="form-group">
          <label for="numberOfPages">
            Number of Pages
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the total number of pages in the book.<br><b>Example:</b> 200"></i>
          </label>
          <input type="number" class="form-control" id="numberOfPages" [(ngModel)]="catalogItem.number_of_pages" name="numberOfPages" placeholder="e.g., 200">
        </div>

        <div class="form-group">
          <label for="notes">
            Notes
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter any additional notes about the book.<br><b>Example:</b> Important for studies"></i>
          </label>
          <textarea class="form-control" id="notes" [(ngModel)]="catalogItem.notes" name="notes" rows="3" placeholder="e.g., Important for studies"></textarea>
        </div>

        <div class="form-group">
          <label for="mediaType">
            Media Type
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Select the media type of the book.<br><b>Example:</b> E-book, Paperback"></i>
          </label>
         <!--  <ng-select
          *ngIf="mediaTypes && mediaTypes.length > 0"
            name="mediaType"
            [items]="mediaTypes"
            bindLabel="name"
            bindValue="id"
            [(ngModel)]="catalogItem.mediaType"
            [searchable]="true"
            placeholder="Select media type">
          </ng-select> -->
          <select
           
            name="mediaType"
            [(ngModel)]="catalogItem.mediaType"
            class="form-control"
            required>
            <option *ngFor="let mediaType of mediaTypes" [ngValue]="mediaType">
              {{ mediaType.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="physicalDescription">
            Physical Description
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Enter the physical description of the book (e.g., hardcover, paperback, etc.)."></i>
          </label>
<!--           <ng-select
            name="writer"
            [items]="physicalDescriptions"
            bindLabel="bindingType"
            bindValue="id"
            [(ngModel)]="catalogItem.writer"
            [searchable]="true"
            placeholder="Select writer">
          </ng-select> -->
          <select
            name="writer"
            [(ngModel)]="catalogItem.physical_description"
            class="form-control">
            <option *ngFor="let description of physicalDescriptions" [ngValue]="description">
              {{ description.bindingType }}
            </option>
          </select>

        </div>

        <div class="form-group">
          <label for="writer">
            Writer
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Select the writer of the book.<br><b>Example:</b> F. Scott Fitzgerald"></i>
          </label>
        <!--   <ng-select
            name="writer"
            [items]="writers"
            bindLabel="name"
            bindValue="id"
            [(ngModel)]="catalogItem.writer"
            [searchable]="true"
            placeholder="Select writer">
          </ng-select> -->
          <select
          name="writer"
          [(ngModel)]="catalogItem.writer"
          class="form-control">
          <option *ngFor="let writer of writers" [ngValue]="writer">
            {{ writer.name }}
          </option>
        </select>

        </div>

        <div class="form-group">
          <label for="publisher">
            Publisher
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Select the publisher of the book.<br><b>Example:</b> Scribner"></i>
          </label>
         <!--  <ng-select
            name="publisher"
            [items]="publishers"
            bindLabel="name"
            bindValue="id"
            [(ngModel)]="catalogItem.publisher"
            [searchable]="true"
            placeholder="Select publisher">
          </ng-select> -->
          <select
          name="publisher"
          [(ngModel)]="catalogItem.publisher"
          class="form-control">
          <option *ngFor="let publisher of publishers" [ngValue]="publisher">
            {{ publisher.name }}
          </option>
        </select>

        </div>

        <div class="form-group">
          <label for="department">
            Department
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Select the department for the book.<br><b>Example:</b> Literature"></i>
          </label>
          <!-- <ng-select
            name="department"
            [items]="departments"
            bindLabel="departmentName"
            bindValue="id"
            [(ngModel)]="catalogItem.departement"
            [searchable]="true"
            placeholder="Select department">
          </ng-select> -->
          <select
            name="department"
            [(ngModel)]="catalogItem.departement"
            class="form-control">
            <option *ngFor="let department of departments" [ngValue]="department">
              {{ department.departmentName }}
            </option>
          </select>

        </div>

        <div class="form-group">
          <label for="shelf">
            Shelf
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Select the shelf location for the book.<br><b>Example:</b> Shelf 3A"></i>
          </label>
         <!--  <ng-select
            name="shelf"
            [items]="shelves"
            bindLabel="location"
            bindValue="id"
            [(ngModel)]="catalogItem.shelf"
            [searchable]="true"
            placeholder="Select shelf">
          </ng-select> -->

          <select
          name="shelf"
          [(ngModel)]="catalogItem.shelf"
          class="form-control">
          <option *ngFor="let shelf of shelves" [ngValue]="shelf">
            {{ shelf.location }}
          </option>
        </select>

        </div>

        <div class="form-group">
          <label for="row">
            Row
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" title="<b>Description:</b> Select the row location for the book.<br><b>Example:</b> Row 2"></i>
          </label>
        <!--   <ng-select
            name="row"
            [items]="rows"
            bindLabel="rowName"
            bindValue="id"
            [(ngModel)]="catalogItem.row"
            [searchable]="true"
            placeholder="Select row">
          </ng-select> -->
          <select
            name="row"
            [(ngModel)]="catalogItem.row"
            class="form-control">
            <option *ngFor="let row of rows" [ngValue]="row">
              {{ row.rowName }}
            </option>
          </select>

        </div>

        <div class="form-group">
          <label for="category">
            Category
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true" 
               title="<b>Description:</b> Select the category of the book.<br><b>Example:</b> Fiction, Non-fiction"></i>
          </label>
        <!--   <ng-select
            name="category"
            [items]="categories"         
            bindLabel="category_name"              
            bindValue="id"                 
            [(ngModel)]="catalogItem.category"   
            [searchable]="true"
            placeholder="Select category">
          </ng-select> -->
          <select
          name="category"
          [(ngModel)]="catalogItem.category"
          class="form-control">
          <option *ngFor="let category of categories" [ngValue]="category">
            {{ category.category_name }}
          </option>
        </select>

        </div>
        
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Cancel</button>
      <button type="button" class="btn btn-outline-primary" (click)="saveCatalogItem()">Save</button>
    </div>
  </form>
</div>
